/**
 * Case insensitive comparison
 */
export const ciContains = (a: unknown, b: unknown) => {
  if (typeof a !== 'string' || typeof b !== 'string') {
    return a === b
  }

  const lowA = a.toLocaleLowerCase()
  const lowB = b.toLocaleLowerCase()

  return (lowB && lowA.includes(lowB)) || (lowA && lowB.includes(lowA))
}
